import React from 'react';
import WalletTypeView from '@components/WalletTypeView';
import { formatWeekKey, checkIfDateIsWeekKey } from '@screens/WalletV3/utils';


export default function WalletDeductions({ route }) {
  let { type = 'DEDUCTIONS', date_range = {}, nav_params = {} } = route.params;
  if (nav_params?.date_range && checkIfDateIsWeekKey(nav_params.date_range)) {
      date_range = {
        key: nav_params.date_range,
        value: formatWeekKey(nav_params.date_range)
      }
    }
  return <WalletTypeView type={type} date_range={date_range} route={route} />;
}